<template>
    <div 
        :class="[
            'tw:flex tw:items-center tw:gap-3 tw:px-3 tw:py-2 tw:rounded-lg tw:border tw:transition-colors',
            variantClasses[variant].bg,
            variantClasses[variant].border
        ]"
    >
        <div 
            :class="[
                'tw:w-8 tw:h-8 tw:rounded-full tw:flex tw:items-center tw:justify-center tw:flex-shrink-0',
                variantClasses[variant].iconBg
            ]"
        >
            <slot name="icon">
                <i :class="[icon, 'tw:text-white']"></i>
            </slot>
        </div>
        <div class="tw:flex tw:flex-col tw:overflow-hidden">
            <span :class="['tw:text-[10px] tw:uppercase tw:font-bold tw:leading-none', variantClasses[variant].textLabel]">
                {{ label }}
            </span>
            <span :class="['tw:text-xs tw:font-medium tw:truncate', variantClasses[variant].textValue]">
                <slot>{{ value }}</slot>
            </span>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        label: {
            type: String,
            required: true
        },
        value: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        variant: {
            type: String,
            default: 'primary',
            validator: value => ['primary', 'success', 'warning', 'danger', 'info', 'gray'].includes(value)
        }
    });

    const variantClasses = {
        primary: {
            bg: 'tw:bg-blue-50',
            border: 'tw:border-blue-200',
            iconBg: 'tw:bg-blue-500',
            textLabel: 'tw:text-blue-600',
            textValue: 'tw:text-blue-800'
        },
        success: {
            bg: 'tw:bg-green-50',
            border: 'tw:border-green-200',
            iconBg: 'tw:bg-green-500',
            textLabel: 'tw:text-green-600',
            textValue: 'tw:text-green-800'
        },
        warning: {
            bg: 'tw:bg-yellow-50',
            border: 'tw:border-yellow-200',
            iconBg: 'tw:bg-yellow-500',
            textLabel: 'tw:text-yellow-600',
            textValue: 'tw:text-yellow-800'
        },
        danger: {
            bg: 'tw:bg-red-50',
            border: 'tw:border-red-200',
            iconBg: 'tw:bg-red-500',
            textLabel: 'tw:text-red-600',
            textValue: 'tw:text-red-800'
        },
        info: {
            bg: 'tw:bg-cyan-50',
            border: 'tw:border-cyan-200',
            iconBg: 'tw:bg-cyan-500',
            textLabel: 'tw:text-cyan-600',
            textValue: 'tw:text-cyan-800'
        },
        gray: {
            bg: 'tw:bg-gray-50',
            border: 'tw:border-gray-200',
            iconBg: 'tw:bg-gray-500',
            textLabel: 'tw:text-gray-600',
            textValue: 'tw:text-gray-800'
        }
    };
</script>
